import { FC, HTMLAttributes } from "react";
import classNames from "classnames";
import { JourneyType, Price } from "src/Modules/Flights/constants";
import PriceCard from "../components/PriceCard/PriceCard";
import { Divider } from "antd";
import JourneyCardMainSection from "../components/JourneyBasicComponent/JourneyBasicComponent";
import MiniFareRules from "../components/MiniFareRules/MiniFareRules";
import AvailableSeats from "../components/AvailableSeats/AvailableSeats";

const JourneyCardWeb: FC<{
  seatsAvailable: number;
  miniRules: any[];
  priceObject: Price;
  journeyData: JourneyType;
} & HTMLAttributes<HTMLDivElement>> = ({
  seatsAvailable,
  priceObject,
  miniRules,
  className,
  journeyData,
  ...props
}) => {
  return (
    <div
      className={classNames(
        "flex h-full w-full cursor-pointer items-stretch justify-center rounded-xl outline outline-border-default",
        "py-4! gap-2",
        "hover:outline-primary-60 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_8px_32px_color-mix(in_srgb,var(--color-primary-60)_12%,transparent)]",
        className,
      )}
      {...props}
    >
      <div className="flex-7 flex flex-col justify-center gap-2">
        <JourneyCardMainSection journeyData={journeyData} />
        <div className="flex flex-wrap items-center justify-between gap-2 px-5">
          <div className="flex items-center justify-center gap-1">
            <MiniFareRules miniRules={miniRules} />
          </div>
        </div>
      </div>
      <Divider orientation="vertical" className="h-full! self-center!" />
      <div className="md:flex-2 flex flex-1 flex-col items-center justify-center gap-1 text-center md:gap-5">
        <div>
          <PriceCard priceObject={priceObject} />
        </div>
        <div>
          <AvailableSeats seatsAvailable={seatsAvailable} />
        </div>
      </div>
    </div>
  );
};

export default JourneyCardWeb;
